import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M3.703 20.094h3.61V9.25h-3.61zM7.547 5.906q-.015-.812-.563-1.343-.546-.532-1.453-.532-.906 0-1.476.532-.57.531-.57 1.343 0 .798.554 1.336.555.54 1.445.54H5.5q.923 0 1.484-.54.563-.539.563-1.336m9.14 14.188h3.61v-6.219q0-2.406-1.14-3.64Q18.015 9 16.14 9q-2.126 0-3.266 1.828h.031V9.25h-3.61q.048 1.031 0 10.844h3.61V14.03q0-.593.11-.875.234-.546.703-.93.468-.382 1.156-.382 1.812 0 1.813 2.453zM24 4.5v15q0 1.86-1.32 3.18T19.5 24h-15q-1.86 0-3.18-1.32T0 19.5v-15q0-1.86 1.32-3.18T4.5 0h15q1.86 0 3.18 1.32T24 4.5"
    }, null, -1)
  ])))
}
export default { render: render }